const commonErrorMessage = 'Something went wrong. Try again in a few minutes';
const notifications = {
  changes: {
    pending: 'Saving changes...',
    success: 'Changes saved successfully',
    error: commonErrorMessage,
  },
  email: {
    pending: 'Sending email...',
    success: 'Email sent',
    successAsync: 'Your email is on its way! It may take a few minutes',
    error: commonErrorMessage,
  },
  download: {
    pending: 'Exporting [format]...',
    success: 'File downloaded',
    error: commonErrorMessage,
  },
};

export default notifications;
